// extracted by mini-css-extract-plugin
module.exports = {"confirmation_description":"_2Bqlzhf","confirmation_buttons":"tBNBBWt"};